import React, { useState } from 'react'
import { Card, Button, Row, Col, Form } from 'react-bootstrap'
import UpdateCardModal from './UpdateCardModal'
import UpdateAddressModal from './UpdateAddressModal'
import SuccessModal from './SuccessModal' // ✅ import

export default function BillingPayments({ billingAddress, payment }) {
  const [showCardModal, setShowCardModal] = useState(false)
  const [showAddressModal, setShowAddressModal] = useState(false)
  const [showSuccessModal, setShowSuccessModal] = useState(false) // ✅ new state

  const [tempAddress, setTempAddress] = useState(billingAddress)

  const handleAddressChange = e => {
    const { name, value } = e.target
    setTempAddress(prev => ({ ...prev, [name]: value }))
  }

  const handleSaveAddress = () => {
    console.log('Updated Address:', tempAddress)
    setShowAddressModal(false)

    // ✅ show success modal
    setShowSuccessModal(true)
  }

  const handleSaveCard = () => {
    console.log('Updated Card Saved!')
    setShowCardModal(false)
  }

  return (
    <div className='subscription_management'>
      {/* Payment Method */}
      <div className='mt-4'>
        <h2 className='fw-bold h4 mb-4'>Payment Method</h2>
        <Card className='mb-5'>
          <Card.Body>
            <div className='d-flex justify-content-between align-items-center'>
              <div className='d-flex align-items-center'>
                <svg
                  xmlns='http://www.w3.org/2000/svg'
                  width='30'
                  height='20'
                  viewBox='0 0 30 20'
                  className='me-3'
                >
                  <path
                    d='M29.5 3.328a2.5 2.5 0 00-2.5-2.5H3a2.5 2.5 0 00-2.5 2.5V16.672a2.5 2.5 0 002.5 2.5h24a2.5 2.5 0 002.5-2.5V3.328z'
                    fill='#000'
                  />
                  <path
                    d='M26.25 1.5H3.75a2.25 2.25 0 00-2.25 2.25V16.25a2.25 2.25 0 002.25 2.25h22.5a2.25 2.25 0 002.25-2.25V3.75a2.25 2.25 0 00-2.25-2.25z'
                    fill='#fff'
                  />
                  <path d='M3.75 3.75h22.5v12.5H3.75z' fill='#133692' />
                  <path d='M12.5 10a1.25 1.25 0 100-2.5 1.25 1.25 0 000 2.5z' fill='#fff' />
                  <path d='M17.5 10a1.25 1.25 0 100-2.5 1.25 1.25 0 000 2.5z' fill='#fff' />
                  <path d='M15 12.5a1.25 1.25 0 100-2.5 1.25 1.25 0 000 2.5z' fill='#fff' />
                </svg>
                <p className='fw-medium m-0'>{payment.cardNumber}</p>
              </div>
              <Button variant='primary' size='sm' onClick={() => setShowCardModal(true)}>
                Update Card
              </Button>
            </div>
          </Card.Body>
        </Card>

        {/* Billing Address */}
        <h2 className='fw-bold h4 mb-4'>Billing Address</h2>
        <Card>
          <Card.Body>
            <Form>
              <Row>
                <Col md={6}>
                  <Form.Group className='mb-3'>
                    <Form.Label className='small fw-medium'>Company Name</Form.Label>
                    <Form.Control type='text' defaultValue={billingAddress.companyName} disabled />
                  </Form.Group>
                </Col>
                <Col md={6}>
                  <Form.Group className='mb-3'>
                    <Form.Label className='small fw-medium'>Full Name</Form.Label>
                    <Form.Control type='text' defaultValue={billingAddress.fullName} disabled />
                  </Form.Group>
                </Col>
                <Col md={6}>
                  <Form.Group className='mb-3'>
                    <Form.Label className='small fw-medium'>Address</Form.Label>
                    <Form.Control type='text' defaultValue={billingAddress.address} disabled />
                  </Form.Group>
                </Col>
                <Col md={6}>
                  <Form.Group className='mb-3'>
                    <Form.Label className='small fw-medium'>City</Form.Label>
                    <Form.Control type='text' defaultValue={billingAddress.city} disabled />
                  </Form.Group>
                </Col>
                <Col md={6}>
                  <Form.Group className='mb-3'>
                    <Form.Label className='small fw-medium'>State</Form.Label>
                    <Form.Control type='text' defaultValue={billingAddress.state} disabled />
                  </Form.Group>
                </Col>
                <Col md={6}>
                  <Form.Group className='mb-3'>
                    <Form.Label className='small fw-medium'>Country</Form.Label>
                    <Form.Control type='text' defaultValue={billingAddress.country} disabled />
                  </Form.Group>
                </Col>
              </Row>
              <div className='text-end mt-2'>
                <Button variant='primary' size='sm' onClick={() => setShowAddressModal(true)}>
                  Update Address
                </Button>
              </div>
            </Form>
          </Card.Body>
        </Card>
      </div>

      {/* Modals */}
      <UpdateCardModal
        show={showCardModal}
        onHide={() => setShowCardModal(false)}
        onConfirm={handleSaveCard}
      />

      <UpdateAddressModal
        show={showAddressModal}
        onHide={() => setShowAddressModal(false)}
        onConfirm={handleSaveAddress}
        tempAddress={tempAddress}
        onAddressChange={handleAddressChange}
      />

      {/* ✅ Success Modal */}
      <SuccessModal
        show={showSuccessModal}
        onHide={() => setShowSuccessModal(false)}
        title='Address Updated'
        message='Your billing address has been successfully updated.'
      />
    </div>
  )
}
